module.exports = __webpack_public_path__ + "assets/images/sizeofboat-04.b792c377b8ba1f5496676c792029b7da.svg";